import { FC } from 'react'

import './style.scss'
import { usePagination, DOTS } from './usePagination'

type PaginateProps = {
  className?: string,
  current: number,
  size?: number,
  total: number,
  onPageChange(current: number): void
}

const Paginate:FC<PaginateProps> = ({ className = '', current = 1, size = 10, total = 1, onPageChange })  => {
  const paginationRange = usePagination({
    currentPage: current,
    totalCount: total,
    siblingCount: 1,
    pageSize: size
  })

  if (current === 0 || paginationRange.length < 2) return null

  const onNext = () => onPageChange(current + 1)

  const onPrevious = () => onPageChange(current - 1)

  const lastPage = paginationRange[paginationRange.length - 1]

  return (
    <ul className={`paginate ${className}`}>
      <li
        className={`paginate_item ${current === 1 ? 'paginate_item--disabled' : ''}`}
        onClick={current > 1 ? onPrevious : undefined}
      >
        <span>&#10094;</span>
      </li>

      {paginationRange.map(pageNumber => {
        if (pageNumber === DOTS) {
          return <li className="paginate_item paginate_item--dots">&#8230;</li>;
        }

        return (
          <li
            key={pageNumber}
            className={`paginate_item ${current === pageNumber ? 'paginate_item--active' : ''}`}
            onClick={() => current !== pageNumber ? onPageChange(Number(pageNumber)) : undefined}
          >
            {pageNumber}
          </li>
        );
      })}

      <li
        className={`paginate_item ${current === lastPage ? 'paginate_item--disabled' : ''}`}
        onClick={current < lastPage ? onNext : undefined}
      >
        <span>&#10095;</span>
      </li>
    </ul>
  )
}

export { Paginate }